<template>
    <div>
        <input type="hidden" name="_token" :value="csrf">
        <input name="applicantRoles[person_id]" type="hidden" v-model="this.person_id">

        <div class="row align-items-end mt-3">
            <div class="col-12 col-md-4">
                <div class="form-group mb-0">
                    <select v-model="newRole" class="form-control">
                        <option disabled value="">{{ __('misc.select') }}</option>
                        <option v-for="(role) in this.roles" :value="role.id" :key="role.id"> {{ role.name }}</option>
                    </select>
                </div>
            </div>
            <div class="col-12 col-md-8">
                <button @click="addRole" class="btn btn--green" type="button"> {{ __("misc.add") }}</button>
            </div>
        </div>

        <div class="table-responsive mt-3">
            <table class="table">
                <thead>
                    <tr>
                        <th>{{ __("forms.BaseCharts.role") }}</th>
                        <th>{{ __("forms.RecruitingApplicant.roleCandidatureDate") }}</th>
                        <th>{{ __("misc.actions") }}</th>
                    </tr>
                </thead>
                <tbody v-for="(roleApplicant, index) in rolesApplicant" :key="index">

                    <tr>
                        <td>
                            {{ roleApplicant.name }}
                        </td>

                        <td>
                            {{ roleApplicant.created_at }}
                        </td>

                        <td>
                            <button type="button"
                                class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove mx-1"
                                @click="rmRole(roleApplicant)">
                                <i class="fas fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        getApplicantRoles() {
            axios.get("/applicant-roles/" + this.person_id + "/person")
                .then((response) => {
                    this.rolesApplicant = response.data;
                });
        },
        updateApplicantRole(index, event) {

            axios.put("/applicant-roles/" + index + "/update",
                {
                    recruitingApplicantRole:
                    {
                        role_id: event.target.value,
                    }
                })
                .then((response) => {
                    this.getApplicantRoles();
                });
        },
        rmRole(row) {

            //Delete element
            axios.delete("/applicant-roles", {
                data: {
                    recruitingApplicantRole: {
                        role_id: row.id,
                        person_id: this.person_id
                    }
                }
            })
                .then((response) => {
                    this.getApplicantRoles();
                });
        },
        addRole() {

            //Check if
            if (this.newRole === null) {
                alert("Non puoi lasciare campi vuoti");
                return;
            }
            let postData = {
                recruitingApplicantRole: {
                    role_id: this.newRole,
                    person_id: this.person_id
                }
            };
            axios.post('/applicant-roles/store', postData)
                .then(response => {
                    this.getApplicantRoles();
                });
        },
    },
    mounted() {
        this.getApplicantRoles()
    },
    data() {
        return {
            action: "",
            newRole: null,
            rolesApplicant: [],
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),

        }
    },
    props: {
        person_id: {
            type: Number,
            required: true
        },
        roles: {
            type: Array,
            required: true
        },
    }
}
</script>

